import React from 'react';
// import { FaPlusCircle } from "react-icons/fa";
import {
    Row,
    Col,
    Statistic,
    Table,
    Space,
} from 'antd';
// import axios from '../../../config/axios';
import dayjs from 'dayjs';
// import EditFormModal from './EditFormModal';
import DeletePopupButton from './DeletePopupButton';
// import axios from '../../../config/axios';

const columns = (orderId, orderItems, form) => [
    {
        title: 'No.',
        dataIndex: 'no',
        key: 'no',
        width: '20px'
    },
    {
        title: 'Details',
        dataIndex: 'product',
        key: 'product',
        render: (text, option) => (
            <div>
                <span style={{ display: 'block', fontWeight: 'bold' }}>
                    {`${text.name}`}
                </span>
                {text.category.name === 'course' && <span style={{ fontSize: '12px' }}>
                    {`เริ่มเรียน ${dayjs(option.start_date).format('DD-MM-YYYY')} ถึง ${dayjs(option.end_date).format('DD-MM-YYYY')}`}
                </span>}
            </div>
        )
    },
    {
        title: 'Price',
        dataIndex: 'price',
        key: 'price',
        render: (text, _) => <Statistic value={text} precision={2} valueStyle={{ fontSize: 14, textAlign: 'right' }} />,
    },
    {
        title: 'Quantity',
        dataIndex: 'quantity',
        key: 'quantity',
        render: (text, _) => <Statistic value={text} valueStyle={{ fontSize: 14, textAlign: 'right' }} />,
    },
    {
        title: '',
        dataIndex: 'action',
        key: 'action',
        render: (_, record) => (
            <Space size="middle">
                {/* <EditFormModal data={record} orderId={orderId} orderItems={orderItems} form={form} /> */}
                <DeletePopupButton data={record} orderId={orderId} orderItems={orderItems} form={form} />
            </Space>
        ),
    },
]

function OrderItems({ orderItems, orderId, form }) {


    return (
        <Row justify='end' gutter={[16, 16]}>
            <Col xs={24}>
                <Table
                    rowKey={(record) => record._id}
                    columns={columns(orderId, orderItems, form)}
                    dataSource={orderItems.map((item, idx) => ({ ...item, no: idx + 1 }))}
                    pagination={false}
                    scroll={{
                        x: 800,
                    }}
                />
            </Col>
        </Row>
    )
}

export default OrderItems